webpackJsonp([3],{

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_action_new_vue__ = __webpack_require__(770);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0390c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_action_new_vue__ = __webpack_require__(907);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_page_action_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c0390c8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_page_action_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(544));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(543));

var _alphaNum = _interopRequireDefault(__webpack_require__(546));

var _numeric = _interopRequireDefault(__webpack_require__(547));

var _between = _interopRequireDefault(__webpack_require__(548));

var _email = _interopRequireDefault(__webpack_require__(549));

var _ipAddress = _interopRequireDefault(__webpack_require__(550));

var _macAddress = _interopRequireDefault(__webpack_require__(551));

var _maxLength = _interopRequireDefault(__webpack_require__(552));

var _minLength = _interopRequireDefault(__webpack_require__(553));

var _required = _interopRequireDefault(__webpack_require__(554));

var _requiredIf = _interopRequireDefault(__webpack_require__(555));

var _requiredUnless = _interopRequireDefault(__webpack_require__(556));

var _sameAs = _interopRequireDefault(__webpack_require__(557));

var _url = _interopRequireDefault(__webpack_require__(558));

var _or = _interopRequireDefault(__webpack_require__(559));

var _and = _interopRequireDefault(__webpack_require__(560));

var _not = _interopRequireDefault(__webpack_require__(561));

var _minValue = _interopRequireDefault(__webpack_require__(562));

var _maxValue = _interopRequireDefault(__webpack_require__(563));

var _integer = _interopRequireDefault(__webpack_require__(564));

var _decimal = _interopRequireDefault(__webpack_require__(565));

var helpers = _interopRequireWildcard(__webpack_require__(541));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'ACL001',"APP_NAME":'"ACL"',"QUIPU_URL":'undefined',"MOCK_URL":'https://jsonplaceholder.typicode.com',"ACL_URL":'https://acl.casamarketapp.com/api',"SALES_URL":'https://sales.apprunn.net',"ACL_URL_COMPANY":'https://midecommerce.casamarketapp.com',"STORAGE_USER_KEY":"acl","S3_IMAGES_URL":'//s3.amazonaws.com/apprunn-acl',"COMPANY_LOGIN_TITLE":'ACL',"COMPANY_LOGIN_BACKGROUND":'https://s3.amazonaws.com/apprunn-acl/bg-login.jpg',"ACCEPT_SERVICE_V2":'application/vnd.apiacl.v2+json'}).BUILD === 'web' ? __webpack_require__(545).withParams : __webpack_require__(152).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(73)))

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 554:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 555:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 557:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 565:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(541);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(578);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(156);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(579), __esModule: true };

/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(75);
__webpack_require__(74);
module.exports = __webpack_require__(580);


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(76);
var ITERATOR = __webpack_require__(11)('iterator');
var Iterators = __webpack_require__(22);
module.exports = __webpack_require__(10).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),

/***/ 590:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_six_four__);



var getFile = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileInfo) {
		var _this = this;

		var newFile, words, lastItem, extension, _ref2, response, newImage;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.isLoadingImage = true;
						newFile = {
							name: fileInfo.name.replace(/\s/g, '-'),
							type: fileInfo.type,
							image: fileInfo.sixFour
						};
						_context.prev = 2;
						words = newFile.name.split('.');
						lastItem = words.length;
						extension = words[lastItem - 1];

						if (!(this.allowedFiles.indexOf(extension) > -1)) {
							_context.next = 14;
							break;
						}

						_context.next = 9;
						return this.$http.post('image/one-upload', newFile);

					case 9:
						_ref2 = _context.sent;
						response = _ref2.data;

						if (extension === 'pdf') {
							this.$emit('send-file', { file: response.data.url_image });
							this.isLoadingImage = false;
						} else {
							newImage = new Image();

							newImage.onload = function () {
								if (newImage.naturalWidth <= _this.allowedMaxSize) {
									var model = {
										urlImage: response.data.url_image
									};
									if (_this.itemUpdate) {
										model.item = _this.itemUpdate;
									}
									_this.$emit('send-image', model);
									_this.isLoadingImage = false;
								} else {
									_this.showNotification('El tama\xF1o m\xE1ximo permitido es ' + _this.allowedMaxSize + ' x ' + _this.allowedMaxSize, 'warning');
									_this.isLoadingImage = false;
								}
							};
							newImage.src = response.data.url_image;
						}
						_context.next = 15;
						break;

					case 14:
						this.showNotification('Archivo no v\xE1lido, solo se permite ' + this.allowedFiles.join(','), 'warning');

					case 15:
						_context.next = 20;
						break;

					case 17:
						_context.prev = 17;
						_context.t0 = _context['catch'](2);

						this.showError();

					case 20:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[2, 17]]);
	}));

	return function getFile(_x) {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function actionUploadImage() {
	this.$refs[this.labelRef].click();
}

function data() {
	return {
		allowedFiles: ['jpg', 'jpeg', 'png', 'svg', 'pdf'],
		isLoadingImage: false,
		newImage: ''
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'upload-image',
	components: {
		VueSixFour: __WEBPACK_IMPORTED_MODULE_2_vue_six_four___default.a
	},
	data: data,
	methods: {
		actionUploadImage: actionUploadImage,
		getFile: getFile
	},
	props: {
		allowedMaxSize: {
			type: Number,
			default: 25
		},
		buttonTitle: {
			default: 'Cambiar de icono',
			type: String
		},
		inputId: {
			type: [Number, String]
		},
		itemUpdate: {
			type: Object,
			default: function _default() {}
		},
		labelFor: {
			type: [Number, String]
		},
		labelRef: {
			type: [Number, String]
		}
	}
});

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=0)}([function(e,t,n){e.exports=n(1)},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(3),o=n(5),i=n(2),l=i(r.a,o.a,!1,null,null,null);t.default=l.exports},function(e,t){e.exports=function(e,t,n,r,o,i){var l,u=e=e||{},s=typeof e.default;"object"!==s&&"function"!==s||(l=e,u=e.default);var a="function"==typeof u?u.options:u;t&&(a.render=t.render,a.staticRenderFns=t.staticRenderFns,a._compiled=!0),n&&(a.functional=!0),o&&(a._scopeId=o);var c;if(i?(c=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"==typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),r&&r.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i)},a._ssrRegister=c):r&&(c=r),c){var f=a.functional,p=f?a.render:a.beforeCreate;f?(a._injectStyles=c,a.render=function(e,t){return c.call(t),p(e,t)}):a.beforeCreate=p?[].concat(p,c):[c]}return{esModule:l,exports:u,options:a}}},function(e,t,n){"use strict";function r(){return{multipleFiles:[]}}function o(e){for(var t=this,n=e.target.files,r=n.length,o=0;o<r;o+=1)(function(e){var o=n[e],i=new FileReader;i.readAsDataURL(o),i.addEventListener("load",function(){var e=l()(o,{sixFour:i.result});t.multipleFiles.push(e),r===t.multipleFiles.length&&(t.$emit("vue-six-four",t.allowMultiple?t.multipleFiles:t.multipleFiles[0]),t.multipleFiles=[]),i=null})})(o)}var i=n(4),l=n.n(i);t.a={data:r,name:"vue-six-four",methods:{readFile:o},props:{allowMultiple:{type:Boolean,default:!1}}}},function(e,t){e.exports=__webpack_require__(46)},function(e,t,n){"use strict";var r=function(){var e=this,t=e.$createElement;return(e._self._c||t)("input",{attrs:{type:"file",multiple:e.allowMultiple},on:{change:e.readFile}})},o=[],i={render:r,staticRenderFns:o};t.a=i}]);

/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e152234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e152234_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{ref:_vm.labelRef,attrs:{"for":_vm.labelFor}},[_c('vue-six-four',{attrs:{"id":_vm.inputId,"hidden":""},on:{"vue-six-four":_vm.getFile}}),_vm._v(" "),_c('v-btn',{staticClass:"btn-action caption",attrs:{"color":"primary"},on:{"click":_vm.actionUploadImage}},[_vm._v("\n\t\t\t"+_vm._s(_vm.buttonTitle)+"\n\t\t")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(730);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(731), __esModule: true };

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(74);
__webpack_require__(732);
module.exports = __webpack_require__(10).Array.from;


/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(30);
var $export = __webpack_require__(17);
var toObject = __webpack_require__(47);
var call = __webpack_require__(163);
var isArrayIter = __webpack_require__(164);
var toLength = __webpack_require__(82);
var createProperty = __webpack_require__(733);
var getIterFn = __webpack_require__(83);

$export($export.S + $export.F * !__webpack_require__(165)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(29);
var createDesc = __webpack_require__(77);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);



/* eslint-disable max-len */
var compose = function compose() {
	for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
		fns[_key] = arguments[_key];
	}

	return function () {
		for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
			args[_key2] = arguments[_key2];
		}

		return fns.reduceRight(function (res, fn) {
			return [fn.call.apply(fn, [null].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(res)))];
		}, args)[0];
	};
};

/* eslint-disable prefer-const */
function equality() {
	for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
		args[_key3] = arguments[_key3];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	if (!prop2) {
		prop2 = prop1;
	}
	return function inner(item) {
		return item[prop1] === prop2;
	};
}

function find(fn, col) {
	return col.find(fn);
}

function matchBetweenArrays(collection1, collection2) {
	var _collection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection1, 2),
	    arr1 = _collection[0],
	    prop1 = _collection[1];

	var _collection2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(collection2, 2),
	    arr2 = _collection2[0],
	    prop2 = _collection2[1];

	var list = [];
	if (prop2) {
		arr1.forEach(function (a) {
			var val = prop1 ? a[prop1] : a;
			var match = find(equality(prop2, val), arr2);
			list = list.concat(match);
		});
	}
	if (arr1.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	}) && arr2.every(function (a) {
		return typeof a === 'string' || typeof a === 'number';
	})) {
		arr1.forEach(function (a) {
			var match = arr2.find(function (b) {
				return a === b;
			});
			list = match ? list.concat(match) : list;
		});
	}
	return list;
}

function getDeeper() {
	for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
		args[_key4] = arguments[_key4];
	}

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		}
		args.forEach(function (el) {
			newItem = (newItem || {})[el];
		});
		return newItem;
	};
}

function setNewProperty(property, value) {
	return function p(obj) {
		var newObj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
		newObj[property] = value;
		return newObj;
	};
}

function updateItemInCollection(matchProp, ele, collection) {
	return collection.reduce(function (list, item) {
		if (ele[matchProp] === item[matchProp]) {
			return list.concat(ele);
		}
		return list.concat(item);
	}, []);
}

function getPropertysValue(prop) {
	return function inner(obj) {
		return (obj || {})[prop];
	};
}

function createPropertyByOtherOne() {
	for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
		args[_key5] = arguments[_key5];
	}

	var prop1 = args[0],
	    prop2 = args[1];

	return function inner(item) {
		var newItem = null;
		if (item.length) {
			var _item2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 1);

			newItem = _item2[0];
		} else {
			newItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item);
		}
		newItem[prop1] = getPropertysValue(prop2)(newItem);
		return newItem;
	};
}

function filter(fn, collection) {
	return collection.filter(fn);
}

function setNewPropertyByFunction(prop, fn) {
	var flag = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

	return function inner(item, index) {
		if (index === null || index === undefined) {
			if (item.length) {
				var _item3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(item, 2),
				    newItem = _item3[0],
				    newIndex = _item3[1];

				return [setNewProperty(prop, fn(newItem, newIndex))(newItem), newIndex];
			}
			return setNewProperty(prop, fn(item, index))(item);
		}
		if (flag) {
			return [setNewProperty(prop, fn(item, index))(item), index];
		}
		return setNewProperty(prop, fn(item, index))(item);
	};
}

function removeItemFromArray(prop, propValue) {
	return function inner(arr) {
		var newArr = arr || [];
		return newArr.reduce(function (list, item) {
			var newList = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(list));
			if (propValue === item[prop]) {
				return newList;
			}
			return newList.concat(item);
		}, []);
	};
}

function removeItemFromArrayByIndex(index, arr) {
	return arr.reduce(function (list, item, ind) {
		var newList = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(list));
		if (index === ind) {
			return newList;
		}
		return newList.concat(item);
	}, []);
}

/* harmony default export */ __webpack_exports__["a"] = ({
	compose: compose,
	createPropertyByOtherOne: createPropertyByOtherOne,
	equality: equality,
	filter: filter,
	find: find,
	getDeeper: getDeeper,
	getPropertysValue: getPropertysValue,
	matchBetweenArrays: matchBetweenArrays,
	removeItemFromArray: removeItemFromArray,
	removeItemFromArrayByIndex: removeItemFromArrayByIndex,
	setNewProperty: setNewProperty,
	setNewPropertyByFunction: setNewPropertyByFunction,
	updateItemInCollection: updateItemInCollection
});

/***/ }),

/***/ 770:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_actions_action_form__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_shared_action_sidebar__ = __webpack_require__(149);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeModal() {
	this.goTo('page-action');
}

function title() {
	var action = 'Acción';
	return this.id ? 'Editar ' + action : 'Nueva ' + action;
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'page-action-new',
	components: {
		actionForm: __WEBPACK_IMPORTED_MODULE_0__components_actions_action_form__["a" /* default */],
		actionSidebar: __WEBPACK_IMPORTED_MODULE_1__components_shared_action_sidebar__["default"]
	},
	computed: {
		title: title
	},
	methods: {
		closeModal: closeModal
	},
	props: {
		id: {
			type: [Number, String]
		},
		codeProject: {
			type: String
		}
	}
});

/***/ }),

/***/ 771:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_helper__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_shared_upload_image__ = __webpack_require__(625);





var created = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var languagesKeys, headers, _ref2, record, newTitleKeys;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						this.languagesByProject = getLocalData('project-languages');
						languagesKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.languagesByProject);

						this.newTitle = languagesKeys.reduce(function (a, k) {
							var newA = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, a);
							newA[k] = { title: '' };
							return newA;
						}, {});

						if (!(this.mode === 'edit')) {
							_context.next = 12;
							break;
						}

						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context.next = 7;
						return this.$http.get('action-bar/' + this.actionId, { headers: headers });

					case 7:
						_ref2 = _context.sent;
						record = _ref2.data;

						if (record.data) {
							if (record.data.flagNew && !record.data.newTitle) {
								newTitleKeys = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.newTitle);

								newTitleKeys.forEach(function (k) {
									var text = k === 'es' ? 'Nuevo' : 'New';
									var kTitle = { title: text };
									_this.$set(_this.newTitle, k, kTitle);
								});
								record.data.newTitle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.newTitle);
							}
							this.model = {
								code: record.data.code,
								codeWeb: record.data.codeWeb,
								flagNew: record.data.flagNew,
								hotKeys: record.data.hotKeys,
								languages: record.data.languages,
								newTitle: record.data.newTitle || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.newTitle),
								numFragment: record.data.numFragment,
								pathIcon: record.data.pathIcon,
								position: record.data.position
							};
							this.verifyManualsExist();
						}
						_context.next = 15;
						break;

					case 12:
						this.loadLanguages();
						this.model.pathIcon = 'https:' + this.getImageUrl('icon-action.svg');
						this.model.newTitle = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.newTitle);

					case 15:
						this.model.codeProject = this.codeProject;

					case 16:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function created() {
		return _ref.apply(this, arguments);
	};
}();

var loadLanguages = function () {
	var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
		var headers, _ref5, project, projectLanguages, lang, modelLanguages;

		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};
						_context2.prev = 1;
						_context2.next = 4;
						return this.$http.get('projects/' + this.codeProject, { headers: headers });

					case 4:
						_ref5 = _context2.sent;
						project = _ref5.data;
						projectLanguages = project.data.languages;
						lang = {};

						__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(projectLanguages).forEach(function (pLangKey) {
							if (projectLanguages[pLangKey].isSelected) {
								lang[pLangKey] = {
									id: projectLanguages[pLangKey].id,
									name: '',
									description: '',
									link: '',
									manuals: []
								};
							}
						});
						modelLanguages = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.model.languages);

						if (modelLanguages.length === 0) {
							this.model.languages = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, lang);
						}
						_context2.next = 16;
						break;

					case 13:
						_context2.prev = 13;
						_context2.t0 = _context2['catch'](1);

						this.showError();

					case 16:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[1, 13]]);
	}));

	return function loadLanguages() {
		return _ref4.apply(this, arguments);
	};
}();

var submitForm = function () {
	var _ref6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
		var method, url, headers;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						method = this.mode === 'create' ? 'post' : 'put';
						url = this.mode === 'create' ? 'action-bar' : 'action-bar/' + this.actionId;
						headers = {
							Accept: '' + 'application/vnd.apiacl.v2+json'
						};

						this.loading = true;
						_context3.prev = 4;
						_context3.next = 7;
						return this.$http[method](url, this.model, { headers: headers });

					case 7:
						this.goTo(PAGE_ACTION_LIST);

					case 8:
						_context3.prev = 8;

						this.loading = false;
						return _context3.finish(8);

					case 11:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[4,, 8, 11]]);
	}));

	return function submitForm() {
		return _ref6.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var PAGE_ACTION_LIST = 'page-action';

var removeItemFromArrayByIndex = __WEBPACK_IMPORTED_MODULE_6__lib__["a" /* default */].removeItemFromArrayByIndex;
var getLocalData = __WEBPACK_IMPORTED_MODULE_5__shared_helper__["a" /* default */].getLocalData;


function verifyManualsExist() {
	var _this2 = this;

	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.model.languages).forEach(function (key) {
		if (!_this2.model.languages[key].manuals) {
			_this2.$set(_this2.model.languages[key], 'manuals', []);
		}
	});
}

function buttonDisabled() {
	return this.$v.$invalid || this.languagesEmpty || this.loading;
}

function closeModal() {
	this.goTo(PAGE_ACTION_LIST);
}

function getImage(_ref3) {
	var urlImage = _ref3.urlImage;

	this.model.pathIcon = urlImage;
}

function flagNewName() {
	return this.model.flagNew ? 'Sí' : 'No';
}

function languagesEmpty() {
	var _this3 = this;

	var disabled = true;
	__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.model.languages).forEach(function (key) {
		if (_this3.model.languages[key].name && _this3.model.languages[key].description) {
			disabled = false;
		}
	});
	return disabled;
}

function mode() {
	return this.actionId ? 'edit' : 'create';
}

function removeKey(item) {
	var index = this.model.hotKeys.indexOf(item);
	if (index > -1) {
		this.model.hotKeys.splice(index, 1);
	}
}

function getManual(man, index) {
	this.model.languages[index].manuals = this.model.languages[index].manuals.concat(man);
}

function updateManuals(index, indexMan) {
	var _this4 = this;

	setTimeout(function () {
		_this4.model.languages[index].manuals = removeItemFromArrayByIndex(indexMan, _this4.model.languages[index].manuals);
	}, 500);
}

function validations() {
	var _this5 = this;

	var validation = {
		model: {
			code: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			},
			codeProject: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			},
			codeWeb: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			},
			languages: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			},
			newTitle: {
				en: {
					title: {
						required: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["requiredIf"])(function () {
							return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this5.newTitle).find(function (k) {
								return k === 'en';
							}) && _this5.model.flagNew;
						})
					}
				},
				es: {
					title: {
						required: Object(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["requiredIf"])(function () {
							return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this5.newTitle).find(function (k) {
								return k === 'es';
							}) && _this5.model.flagNew;
						})
					}
				}
			},
			pathIcon: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			},
			position: {
				required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"]
			}
		}
	};
	return validation;
}

function data() {
	return {
		languagesByProject: {},
		loading: false,
		model: {
			code: '',
			codeProject: '',
			codeWeb: '',
			flagNew: false,
			hotKeys: [],
			languages: {},
			newTitle: {},
			numFragment: null,
			pathIcon: '',
			position: null
		},
		newTitle: {}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'action-form',
	created: created,
	components: {
		UploadImage: __WEBPACK_IMPORTED_MODULE_7__components_shared_upload_image__["a" /* default */]
	},
	computed: {
		buttonDisabled: buttonDisabled,
		flagNewName: flagNewName,
		languagesEmpty: languagesEmpty,
		mode: mode
	},
	data: data,
	methods: {
		closeModal: closeModal,
		getImage: getImage,
		getManual: getManual,
		loadLanguages: loadLanguages,
		removeKey: removeKey,
		submitForm: submitForm,
		updateManuals: updateManuals,
		verifyManualsExist: verifyManualsExist
	},
	props: {
		actionId: {
			type: [Number, String]
		},
		codeProject: {
			type: String,
			required: true
		}
	},
	validations: validations
});

/***/ }),

/***/ 905:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_form_vue__ = __webpack_require__(771);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6daf4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_form_vue__ = __webpack_require__(906);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c6daf4c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 906:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-sidebar',[_c('v-form',{attrs:{"method":"post"},on:{"submit":function($event){$event.preventDefault();return _vm.submitForm($event)}}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Código","required":"","error":_vm.$v.model.code.$error},model:{value:(_vm.$v.model.code.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.code, "$model", $$v)},expression:"$v.model.code.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Url Web","required":"","error":_vm.$v.model.codeWeb.$error},model:{value:(_vm.$v.model.codeWeb.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.codeWeb, "$model", $$v)},expression:"$v.model.codeWeb.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Fragment Móvil","type":"number"},model:{value:(_vm.model.numFragment),callback:function ($$v) {_vm.$set(_vm.model, "numFragment", _vm._n($$v))},expression:"model.numFragment"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Posición","type":"number","error":_vm.$v.model.position.$error},model:{value:(_vm.$v.model.position.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.position, "$model", $$v)},expression:"$v.model.position.$model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-combobox',{staticClass:"body-1",attrs:{"background-color":"white","box":"","small-chips":"","clearable":"","hide-details":"","label":"Teclas de acceso rápido","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"close":"","small":""},on:{"input":function($event){_vm.removeKey(item)}}},[_c('strong',[_vm._v(_vm._s(item))]),_vm._v(" \n\t\t\t\t\t\t\t")])]}}]),model:{value:(_vm.model.hotKeys),callback:function ($$v) {_vm.$set(_vm.model, "hotKeys", $$v)},expression:"model.hotKeys"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},_vm._l((_vm.model.languages),function(language,index){return _c('v-layout',{key:language.id,attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm1":""}},[_c('label',{attrs:{"for":"language"}},[_vm._v(_vm._s(index))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs9":"","sm11":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Nombre"},model:{value:(language.name),callback:function ($$v) {_vm.$set(language, "name", $$v)},expression:"language.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"body-1",attrs:{"background-color":"white","box":"","height":"80","hide-details":"","label":"Descripción","no-resize":""},model:{value:(language.description),callback:function ($$v) {_vm.$set(language, "description", $$v)},expression:"language.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","label":"Link de video"},model:{value:(language.link),callback:function ($$v) {_vm.$set(language, "link", $$v)},expression:"language.link"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","d-flex":""}},[_c('upload-image',{attrs:{"label-ref":"up","label-for":(index + "-manual"),"input-id":(index + "-manual"),"button-title":"Cargar archivo"},on:{"send-file":function($event){_vm.getManual($event, index)}}}),_vm._v(" "),_c('div',_vm._l((language.manuals),function(manual,indexMan){return _c('v-text-field',{key:indexMan,staticClass:"body-1 mx-2 mt-0",attrs:{"solo":"","hide-details":"","clearable":"","readonly":"","height":"30px"},on:{"click:clear":function($event){_vm.updateManuals(index, indexMan)}},model:{value:(manual.file),callback:function ($$v) {_vm.$set(manual, "file", $$v)},expression:"manual.file"}})}))],1)],1)],1)],1)})),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pb-3":""}},[_c('v-layout',{attrs:{"wrap":"","align-center":""}},[_c('upload-image',{attrs:{"label-ref":"up","label-for":"image","input-id":"image"},on:{"send-image":_vm.getImage}}),_vm._v(" "),_c('v-text-field',{staticClass:"body-1 mx-2 mt-0",attrs:{"solo":"","height":"30px","hide-details":"","required":"","label":"Icono","error":_vm.$v.model.pathIcon.$error},model:{value:(_vm.$v.model.pathIcon.$model),callback:function ($$v) {_vm.$set(_vm.$v.model.pathIcon, "$model", $$v)},expression:"$v.model.pathIcon.$model"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"wrap":"","row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs5":"","py-0":""}},[_c('label',{staticClass:"body-2"},[_vm._v("Agregar etiqueta")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","py-0":""}},[_c('v-switch',{staticClass:"mt-0",attrs:{"color":"base","hide-details":"","label":_vm.flagNewName},model:{value:(_vm.model.flagNew),callback:function ($$v) {_vm.$set(_vm.model, "flagNew", $$v)},expression:"model.flagNew"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","caption":"","py-0":""}},[_c('span',[_vm._v("Se mostrará junto al nombre de la acción (Ej.: Nuevo, Beta, etc...)")])])],1),_vm._v(" "),(_vm.model.flagNew)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.languagesByProject),function(language,lanKey){return _c('v-flex',{key:lanKey,attrs:{"xs12":""}},[_c('label',[_vm._v(_vm._s(language.name)+":")]),_vm._v(" "),_c('v-text-field',{staticClass:"body-1",attrs:{"background-color":"white","box":"","hide-details":"","required":""},model:{value:(_vm.model.newTitle[lanKey].title),callback:function ($$v) {_vm.$set(_vm.model.newTitle[lanKey], "title", $$v)},expression:"model.newTitle[lanKey].title"}})],1)})):_vm._e(),_vm._v(" "),_c('section',{staticClass:"modal-filter-footer"},[_c('modal-sidebar-button',{attrs:{"is-loading":_vm.buttonDisabled,"on-run-service":_vm.loading},on:{"accept-button-clicked":_vm.submitForm,"cancel-button-clicked":_vm.closeModal}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 907:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('action-sidebar',{attrs:{"title":_vm.title,"value":true},on:{"close-modal":_vm.closeModal}},[_c('action-form',{attrs:{"action-id":_vm.id,"code-project":_vm.codeProject}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.70a9a654742a6a2bd806.js